import { render, staticRenderFns } from "./FriendslistView.vue?vue&type=template&id=f7636aee"
import script from "./FriendslistView.vue?vue&type=script&lang=js"
export * from "./FriendslistView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports